export default {
  //get all CHAPTERs
  STUDENTS_PER_GROUP_REQUEST: "STUDENTS_PER_GROUP_REQUEST",
  STUDENTS_PER_GROUP_SUCCESS: "STUDENTS_PER_GROUP_SUCCESS",
  STUDENTS_PER_GROUP_FAIL: "STUDENTS_PER_GROUP_FAIL",

  //edit CHAPTERs
  VIDEO_REPORT_REQUEST: "VIDEO_REPORT_REQUEST",
  VIDEO_REPORT_SUCCESS: "VIDEO_REPORT_SUCCESS",
  VIDEO_REPORT_FAIL: "VIDEO_REPORT_FAIL",

  //create CHAPTER
  ATTENDANCE_REPORT_REQUEST: "ATTENDANCE_REPORT_REQUEST",
  ATTENDANCE_REPORT_SUCCESS: "ATTENDANCE_REPORT_SUCCESS",
  ATTENDANCE_REPORT_FAIL: "ATTENDANCE_REPORT_FAIL",

  EXAM_REPORT_REQUEST: "EXAM_REPORT_REQUEST",
  EXAM_REPORT_SUCCESS: "EXAM_REPORT_SUCCESS",
  EXAM_REPORT_FAIL: "EXAM_REPORT_FAIL",

  UNPAID_REPORT_REQUEST: "UNPAID_REPORT_REQUEST",
  UNPAID_REPORT_SUCCESS: "UNPAID_REPORT_SUCCESS",
  UNPAID_REPORT_FAIL: "UNPAID_REPORT_FAIL",

  PAID_REPORT_REQUEST: "PAID_REPORT_REQUEST",
  PAID_REPORT_SUCCESS: "PAID_REPORT_SUCCESS",
  PAID_REPORT_FAIL: "PAID_REPORT_FAIL",

  EXAM_ATTENDANCE_REQUEST: "EXAM_ATTENDANCE_REQUEST",
  EXAM_ATTENDANCE_SUCCESS: "EXAM_ATTENDANCE_SUCCESS",
  EXAM_ATTENDANCE_FAIL: "EXAM_ATTENDANCE_FAIL",
  REPORT_LOADING: "REPORT_LOADING",

  HOMEWORK_ATTENDENCE_REPORT_REQUEST: "HOMEWORK_ATTENDENCE_REPORT_REQUEST",
  HOMEWORK_ATTENDENCE_REPORT_SUCCESS: "HOMEWORK_ATTENDENCE_REPORT_SUCCESS",
  HOMEWORK_ATTENDENCE_REPORT_FAIL: "HOMEWORK_ATTENDENCE_REPORT_FAIL",

  FILTER_HOMEWORK_ATTENDENCE_REPORT_REQUEST:
    "FILTER_HOMEWORK_ATTENDENCE_REPORT_REQUEST",
  FILTER_HOMEWORK_ATTENDENCE_REPORT_SUCCESS:
    "FILTER_HOMEWORK_ATTENDENCE_REPORT_SUCCESS",
  FILTER_HOMEWORK_ATTENDENCE_REPORT_FAIL:
    "FILTER_HOMEWORK_ATTENDENCE_REPORT_FAIL",

  HOMEWORK_ABSENT_REPORT_REQUEST: "HOMEWORK_ABSENT_REPORT_REQUEST",
  HOMEWORK_ABSENT_REPORT_SUCCESS: "HOMEWORK_ABSENT_REPORT_SUCCESS",
  HOMEWORK_ABSENT_REPORT_FAIL: "HOMEWORK_ABSENT_REPORT_FAIL",

  DELETE_STUDENT_HOMEWORK_REQUEST: "DELETE_STUDENT_HOMEWORK_REQUEST",
  DELETE_STUDENT_HOMEWORK_SUCCESS: "DELETE_STUDENT_HOMEWORK_SUCCESS",
  DELETE_STUDENT_HOMEWORK_FAIL: "DELETE_STUDENT_HOMEWORK_FAIL",

  RESTRICT_STUDENT_HOMEWORK_REQUEST: "RESTRICT_STUDENT_HOMEWORK_REQUEST",
  RESTRICT_STUDENT_HOMEWORK_SUCCESS: "RESTRICT_STUDENT_HOMEWORK_SUCCESS",
  RESTRICT_STUDENT_HOMEWORK_FAIL: "RESTRICT_STUDENT_HOMEWORK_FAIL",
  ACCEPT_STUDENT_HOMEWORK_REQUEST: "ACCEPT_STUDENT_HOMEWORK_REQUEST",
  ACCEPT_STUDENT_HOMEWORK_SUCCESS: "ACCEPT_STUDENT_HOMEWORK_SUCCESS",
  ACCEPT_STUDENT_HOMEWORK_FAIL: "ACCEPT_STUDENT_HOMEWORK_FAIL",

  COMMENT_STUDENT_HOMEWORK_REQUEST: "COMMENT_STUDENT_HOMEWORK_REQUEST",
  COMMENT_STUDENT_HOMEWORK_SUCCESS: "COMMENT_STUDENT_HOMEWORK_SUCCESS",
  COMMENT_STUDENT_HOMEWORK_FAIL: "COMMENT_STUDENT_HOMEWORK_FAIL", //loading
  HOMEWORK_UNCOMMENT_REPORT_REQUEST: "HOMEWORK_UNCOMMENT_REPORT_REQUEST",
  HOMEWORK_UNCOMMENT_REPORT_SUCCESS: "HOMEWORK_UNCOMMENT_REPORT_SUCCESS",
  HOMEWORK_UNCOMMENT_REPORT_FAIL: "HOMEWORK_UNCOMMENT_REPORT_FAIL",
  STUDENT_PERFORMANCE_REQUEST: "STUDENT_PERFORMANCE_REQUEST",
  STUDENT_PERFORMANCE_SUCCESS: "STUDENT_PERFORMANCE_SUCCESS",
  STUDENT_PERFORMANCE_FAIL: "STUDENT_PERFORMANCE_FAIL",
  
  CENTER_HW_REQUEST: "CENTER_HW_REQUEST",
  CENTER_HW_SUCCESS: "CENTER_HW_SUCCESS",
  CENTER_HW_FAIL: "CENTER_HW_FAIL",

  VIDEO_ABSENCE_REPORT_REQUEST: "VIDEO_ABSENCE_REPORT_REQUEST",
  VIDEO_ABSENCE_REPORT_SUCCESS: "VIDEO_ABSENCE_REPORT_SUCCESS",
  VIDEO_ABSENCE_REPORT_FAIL: "VIDEO_ABSENCE_REPORT_FAIL",
  VIDEO_ABSENCE_REPORT_LOADING: "VIDEO_ABSENCE_REPORT_LOADING",

  MONTHLY_REPORT_REQUEST: "MONTHLY_REPORT_REQUEST",
  MONTHLY_REPORT_SUCCESS: "MONTHLY_REPORT_SUCCESS",
  MONTHLY_REPORT_FAIL: "MONTHLY_REPORT_FAIL",

  SEND_BULK_CUSTOM_MESSAGE_REQUEST: "SEND_BULK_CUSTOM_MESSAGE_REQUEST",
  SEND_BULK_CUSTOM_MESSAGE_SUCCESS: "SEND_BULK_CUSTOM_MESSAGE_SUCCESS",
  SEND_BULK_CUSTOM_MESSAGE_FAIL: "SEND_BULK_CUSTOM_MESSAGE_FAIL",

  GET_SAVED_MESSAGES_BY_INTERVAL_REQUEST: "GET_SAVED_MESSAGES_BY_INTERVAL_REQUEST",
  GET_SAVED_MESSAGES_BY_INTERVAL_SUCCESS: "GET_SAVED_MESSAGES_BY_INTERVAL_SUCCESS",
  GET_SAVED_MESSAGES_BY_INTERVAL_FAIL: "GET_SAVED_MESSAGES_BY_INTERVAL_FAIL",

  SEND_SAVED_MESSAGES_REQUEST: "SEND_SAVED_MESSAGES_REQUEST",
  SEND_SAVED_MESSAGES_SUCCESS: "SEND_SAVED_MESSAGES_SUCCESS",
  SEND_SAVED_MESSAGES_FAIL: "SEND_SAVED_MESSAGES_FAIL",

  NOTIFY_PARENT_FOR_EXAM_ABSENCE_REQUEST: "NOTIFY_PARENT_FOR_EXAM_ABSENCE_REQUEST",
  NOTIFY_PARENT_FOR_EXAM_ABSENCE_SUCCESS: "NOTIFY_PARENT_FOR_EXAM_ABSENCE_SUCCESS",
  NOTIFY_PARENT_FOR_EXAM_ABSENCE_FAIL: "NOTIFY_PARENT_FOR_EXAM_ABSENCE_FAIL",

  GET_MESSAGES_BY_RECEIVER_PHONE_REQUEST: "GET_MESSAGES_BY_RECEIVER_PHONE_REQUEST",
  GET_MESSAGES_BY_RECEIVER_PHONE_SUCCESS: "GET_MESSAGES_BY_RECEIVER_PHONE_SUCCESS",
  GET_MESSAGES_BY_RECEIVER_PHONE_FAIL: "GET_MESSAGES_BY_RECEIVER_PHONE_FAIL",

  GET_MANUAL_EXAM_MARKS_REQUEST: "GET_MANUAL_EXAM_MARKS_REQUEST",
  GET_MANUAL_EXAM_MARKS_SUCCESS: "GET_MANUAL_EXAM_MARKS_SUCCESS",
  GET_MANUAL_EXAM_MARKS_FAIL: "GET_MANUAL_EXAM_MARKS_FAIL",

  ADD_STUDENT_NOTE_REQUEST: "ADD_STUDENT_NOTE_REQUEST",
  ADD_STUDENT_NOTE_SUCCESS: "ADD_STUDENT_NOTE_SUCCESS",
  ADD_STUDENT_NOTE_FAIL: "ADD_STUDENT_NOTE_FAIL",

  GET_TELEGRAM_ACTIVE_USERS_REQUEST: "GET_TELEGRAM_ACTIVE_USERS_REQUEST",
  GET_TELEGRAM_ACTIVE_USERS_SUCCESS: "GET_TELEGRAM_ACTIVE_USERS_SUCCESS",
  GET_TELEGRAM_ACTIVE_USERS_FAIL: "GET_TELEGRAM_ACTIVE_USERS_FAIL",

  GET_TELEGRAM_INACTIVE_USERS_REQUEST: "GET_TELEGRAM_INACTIVE_USERS_REQUEST",
  GET_TELEGRAM_INACTIVE_USERS_SUCCESS: "GET_TELEGRAM_INACTIVE_USERS_SUCCESS",
  GET_TELEGRAM_INACTIVE_USERS_FAIL: "GET_TELEGRAM_INACTIVE_USERS_FAIL",

  GET_WA_EVENTS_REQUEST: "GET_WA_EVENTS_REQUEST",
  GET_WA_EVENTS_SUCCESS: "GET_WA_EVENTS_SUCCESS",
  GET_WA_EVENTS_FAIL: "GET_WA_EVENTS_FAIL",

  GET_ABSENT_STUDENTS_REQUEST: "GET_ABSENT_STUDENTS_REQUEST",
  GET_ABSENT_STUDENTS_SUCCESS: "GET_ABSENT_STUDENTS_SUCCESS",
  GET_ABSENT_STUDENTS_FAIL: "GET_ABSENT_STUDENTS_FAIL",

  PAYMENT_REPORT_REQUEST: "PAYMENT_REPORT_REQUEST",
  PAYMENT_REPORT_SUCCESS: "PAYMENT_REPORT_SUCCESS",
  PAYMENT_REPORT_FAIL: "PAYMENT_REPORT_FAIL",

  GET_PAID_UNPAID_STUDENTS_REQUEST: "GET_PAID_UNPAID_STUDENTS_REQUEST",
  GET_PAID_UNPAID_STUDENTS_SUCCESS: "GET_PAID_UNPAID_STUDENTS_SUCCESS",
  GET_PAID_UNPAID_STUDENTS_FAIL: "GET_PAID_UNPAID_STUDENTS_FAIL",

  GET_PAID_UNVIEWED_VIDEOS_REQUEST: "GET_PAID_UNVIEWED_VIDEOS_REQUEST",
  GET_PAID_UNVIEWED_VIDEOS_SUCCESS: "GET_PAID_UNVIEWED_VIDEOS_SUCCESS",
  GET_PAID_UNVIEWED_VIDEOS_FAIL: "GET_PAID_UNVIEWED_VIDEOS_FAIL",

  SEND_ATTENDANCE_CUSTOM_MESSAGE_REQUEST: "SEND_ATTENDANCE_CUSTOM_MESSAGE_REQUEST",
  SEND_ATTENDANCE_CUSTOM_MESSAGE_SUCCESS: "SEND_ATTENDANCE_CUSTOM_MESSAGE_SUCCESS",
  SEND_ATTENDANCE_CUSTOM_MESSAGE_FAIL: "SEND_ATTENDANCE_CUSTOM_MESSAGE_FAIL",

  GET_STUDENTS_NOT_VIEWED_VIDEOS_REQUEST: "GET_STUDENTS_NOT_VIEWED_VIDEOS_REQUEST",
  GET_STUDENTS_NOT_VIEWED_VIDEOS_SUCCESS: "GET_STUDENTS_NOT_VIEWED_VIDEOS_SUCCESS",
  GET_STUDENTS_NOT_VIEWED_VIDEOS_FAIL: "GET_STUDENTS_NOT_VIEWED_VIDEOS_FAIL",

  GET_STUDENTS_NOT_ENTERED_EXAM_REQUEST: "GET_STUDENTS_NOT_ENTERED_EXAM_REQUEST",
  GET_STUDENTS_NOT_ENTERED_EXAM_SUCCESS: "GET_STUDENTS_NOT_ENTERED_EXAM_SUCCESS",
  GET_STUDENTS_NOT_ENTERED_EXAM_FAIL: "GET_STUDENTS_NOT_ENTERED_EXAM_FAIL",

  GET_TOTAL_ATTENDANCE_BY_PERIOD_REQUEST: "GET_TOTAL_ATTENDANCE_BY_PERIOD_REQUEST",
  GET_TOTAL_ATTENDANCE_BY_PERIOD_SUCCESS: "GET_TOTAL_ATTENDANCE_BY_PERIOD_SUCCESS",
  GET_TOTAL_ATTENDANCE_BY_PERIOD_FAIL: "GET_TOTAL_ATTENDANCE_BY_PERIOD_FAIL",

  GET_OBSOLETE_NUMBERS_REQUEST: "GET_OBSOLETE_NUMBERS_REQUEST",
  GET_OBSOLETE_NUMBERS_SUCCESS: "GET_OBSOLETE_NUMBERS_SUCCESS",
  GET_OBSOLETE_NUMBERS_FAIL: "GET_OBSOLETE_NUMBERS_FAIL",
};
